export default __webpack_public_path__ + "static/details-700ad8f0d513daba4c18513b82eca3cd.png";